// komponent Checkbox
import React, { FC } from 'react';
import { Checkbox as CheckboxMui, FormControlLabel } from '@mui/material';
import classnames from 'classnames';

import styles from 'theme/components/controls/Checkbox/Checkbox.module.scss';

// typ danych wejściowych
interface IProps {
  checked: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  label?: React.ReactNode | string;
}

const Checkbox: FC<IProps> = ({ checked, disabled, onClick, indeterminate, label }) => (
  <span
    className={classnames(
      styles.componentWrapper,
      { [styles.disabled]: !!disabled },
      'StylePath-Components-Controls-Checkbox'
    )}>
    <FormControlLabel
      sx={{
        m: 0,
        '& .MuiFormControlLabel-label': {
          ml: 1,
          fontSize: 'inherit',
          fontFamily: 'inherit'
        }
      }}
      control={
        <CheckboxMui
          className={classnames(styles.checkbox, {
            [styles.checked]: checked,
            [styles.indeterminate]: indeterminate
          })}
          checked={checked}
          indeterminate={indeterminate}
          onClick={onClick}
          disabled={disabled}
        />
      } label={label} />
  </span>
);

export default Checkbox;
